export const MODE = {
  DIVISION_REP: 'DIVISION_REP',
  OWNER: 'OWNER',
} as const;
export type Mode = typeof MODE[keyof typeof MODE];
